import clsx from 'clsx';

import type { FC, HTMLAttributes } from 'react';

type GroupEmptyTitleProps = HTMLAttributes<HTMLHeadingElement>;

const GroupEmptyTitle: FC<GroupEmptyTitleProps> = ({ children, className, ...props }) => (
  <h2 className={clsx('subtitle', className)} {...props}>
    {children}
  </h2>
);

export { GroupEmptyTitle };
